import { WidgetStreamState } from 'widgets/store/stream/WidgetStreamState';
import { StreamDisableRangeDataState } from 'widgets/store/disableRange/StreamDisableRangeDataState';
import {
    StreamedStateByStreamKey,
    StreamState,
} from 'streamsState/store/streamedData/StreamedDataState.ts';
import { OrderVolumeProfileTimeSeriesData } from '../../api/OrderVolumeProfileElement';

export type OrderVolumeProfileStreamedDataStreamState =
    StreamState<OrderVolumeProfileDataState>;

export type OrderVolumeProfileStreamState =
    WidgetStreamState<OrderVolumeProfileDataState>;

export type OrderVolumeProfileStreamsState = StreamedStateByStreamKey<
    OrderVolumeProfileDataState,
    OrderVolumeProfileStreamState
>;

export interface OrderVolumeProfileDataState
    extends StreamDisableRangeDataState {
    timeSeries: OrderVolumeProfileTimeSeriesData[];
}

export const initialOrderVolumeProfileDataState: OrderVolumeProfileDataState = {
    timeSeries: [],
    disableRange: [],
};

export const initialOrderVolumeProfileStreamState: OrderVolumeProfileStreamState =
    {
        data: initialOrderVolumeProfileDataState,
        messages: [],
    };
